<template lang="pug">
	content-page
		div(slot="nav")
			navigation-default
		h1 {{contentpage.name}}
		ws-content(:value="contentpage.content")
			template(slot="similar-table")
				comparison-table(:slugs="slugs" :showAreaButtons="true")
					template(slot="table-header")
						thead
							tr.table-header
								th
								th.text-left
									v-autocomplete(v-model="slugs[0]" :items="areas" item-text="name" item-value="slug")
										template(#append)
											v-btn(color="accent" depressed icon small)
												v-icon(small) edit
								th.text-left
									v-autocomplete(v-model="slugs[1]" :items="areas" item-text="name" item-value="slug")
										template(#append)
											v-btn(color="accent" depressed icon small)
												v-icon(small) edit
								th.text-left
									v-autocomplete(v-model="slugs[2]" :items="areas" item-text="name" item-value="slug")
										template(#append)
											v-btn(color="accent" depressed icon small)
												v-icon(small) edit
</template>

<script>
import NavigationDefault from '@/components/navigation-default';
import ComparisonTable from '@/components/areas/comparison.vue';
import gql from 'graphql-tag';
import MetaFragment from '@/components/graphql/metaFragment.graphql';

const getAreas = gql`
	query getAreas($path: String, $fallback: String) {
		contentpage(path: $path, fallback: $fallback) {
			id
			name
			slug
			content {
				markdown
			}
			...MetaFragment
		}
		areas {
			name
			slug
		}
	}
	${MetaFragment}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/skigebieden/vergelijken',
			'de-DE': '/skigebiete/vergleichen',
			'nl-BE': '/skigebieden/vergelijken'
		}
	},
	components: { NavigationDefault, ComparisonTable },
	layout: 'default',
	asyncData({ _params, app, route }) {
		return app.$graphClient
			.query({
				query: getAreas,
				variables: {
					path: route.path,
					fallback: ''
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (!data.contentpage) {
					return app.httpError(404, null, 'areas-similar-01', errors);
				}
				if (errors) {
					throw errors[0];
				}

				app.meta(data.contentpage.meta);
				app.ads({ navigation: { visible: true, type: 'spot' } });
				app.breadcrumbs({
					[app.i18n.t(`page.areas:heading`)]: {
						name: 'areas'
					},
					[data.contentpage.name]: {
						name: 'areas-similar'
					}
				});

				return data;
			})
			.catch(app.$destinationNotFoundCatcher)
			.catch(error => {
				return app.httpError(500, null, 'areas-similar-02', error);
			});
	},
	data() {
		return {
			slugs:
				this.$i18n.locale === 'de-DE'
					? [
							'skiwelt-wilder-kaiser',
							'les-trois-vallees',
							'val-gardena-groeden'
					  ]
					: ['skiwelt', 'troisvallees', 'valgardena']
		};
	},
	watch: {
		slugs() {
			window.location.hash = `${this.slugs[0]}:${this.slugs[1]}:${this.slugs[2]}`;
		}
	},
	mounted() {
		if (this.$route.hash) {
			const hash = this.$route.hash.replace('#', '').split(':');
			if (hash.length === 3) this.slugs = hash;
		}
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
